/**
 * @generated SignedSource<<852aa2606d67d2ff32d7951c80bb78e4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type NftAuctionStatus = "CANCELED" | "ENDED" | "LIVE" | "PAUSED" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type NftItemTileAuctionDetails_nftAuction$data = {
  readonly currentBid: {
    readonly ether: string | null;
  } | null;
  readonly endDate: string | null;
  readonly endedConversionRates: {
    readonly rates: ReadonlyArray<{
      readonly " $fragmentSpreads": FragmentRefs<"NftItemTilePrice_etherRates">;
    } | null> | null;
  } | null;
  readonly item: {
    readonly etherRates: ReadonlyArray<{
      readonly " $fragmentSpreads": FragmentRefs<"NftItemTilePrice_etherRates">;
    } | null> | null;
  } | null;
  readonly reservePrice: {
    readonly ether: string | null;
  } | null;
  readonly status: NftAuctionStatus | null;
  readonly winnerAddress: {
    readonly address: string | null;
    readonly ensDomain: string | null;
    readonly publicProfile: {
      readonly profileName: string | null;
    } | null;
  } | null;
  readonly " $fragmentType": "NftItemTileAuctionDetails_nftAuction";
};
export type NftItemTileAuctionDetails_nftAuction$key = {
  readonly " $data"?: NftItemTileAuctionDetails_nftAuction$data;
  readonly " $fragmentSpreads": FragmentRefs<"NftItemTileAuctionDetails_nftAuction">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "ether",
    "storageKey": null
  }
],
v1 = [
  {
    "args": null,
    "kind": "FragmentSpread",
    "name": "NftItemTilePrice_etherRates"
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "NftItemTileAuctionDetails_nftAuction",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "EtherAmount",
      "kind": "LinkedField",
      "name": "currentBid",
      "plural": false,
      "selections": (v0/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "EtherAmount",
      "kind": "LinkedField",
      "name": "reservePrice",
      "plural": false,
      "selections": (v0/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "EthereumAddressType",
      "kind": "LinkedField",
      "name": "winnerAddress",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "address",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PublicProfile",
          "kind": "LinkedField",
          "name": "publicProfile",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "profileName",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "ensDomain",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endDate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "NftItem",
      "kind": "LinkedField",
      "name": "item",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "EtherRates",
          "kind": "LinkedField",
          "name": "etherRates",
          "plural": true,
          "selections": (v1/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "NftConversionRateEvent",
      "kind": "LinkedField",
      "name": "endedConversionRates",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "EtherRates",
          "kind": "LinkedField",
          "name": "rates",
          "plural": true,
          "selections": (v1/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "NftAuction",
  "abstractKey": null
};
})();

(node as any).hash = "9afe15a902538958d6cb43e39edfd503";

export default node;
